/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class EmployeeHubListVO extends JSONable{
  uuid: string | null = null;

  owner: string | null = null;

  name: string | null = null;

  namedLocationCode: string | null = null;

  namedLocationLabel: string | null = null;

  phoneNumber: string | null = null;

  email? = '';

  namedLocationUuid? = ''
}

export class EmployeeHubListUiVo extends EmployeeHubListVO{
  selected = false
}
